import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'

type Content = string | JSX.Element

const LeftCellContent = ({ leftContent }: { leftContent: Content }): JSX.Element =>
  typeof leftContent === 'string' ? (
    <h4 className="typography-body-xxl text-primary-800 md:text-right">{leftContent}</h4>
  ) : (
    leftContent
  )

export type SectionRowProps = {
  leftContent?: Content
  rightContent: JSX.Element
}

const SectionRow = ({ leftContent, rightContent }: SectionRowProps): JSX.Element => (
  <TableRow>
    <TableCell className="border-b border-b-neutral-300">
      {leftContent && <LeftCellContent leftContent={leftContent} />}
    </TableCell>
    <TableCell className="border-b border-b-neutral-300">{rightContent}</TableCell>
  </TableRow>
)

export default SectionRow
